import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BRAND_CONFIG } from '@core/injection-tokens';
import { MultilingualService } from '@core/services';
import { BrandConfig, CMSContent } from '@models/interfaces';
import { AppCenterAnalytics, AppInsightsService, CmsService } from '@shared/services';
import { LogoComponent } from '@shared/components';
import { SetImagePathDirective } from '@shared/directives';

@Component({
  standalone: true,
  selector: 'app-privacy-policy',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  imports: [LogoComponent, SetImagePathDirective],
})
export class PrivacyPolicyComponent implements OnInit {
  readonly privacyPolicy = signal<CMSContent | null>(null);
  readonly isLoading = signal(false);
  readonly isError = signal(false);
  readonly errMsg = signal<string>('');

  constructor(
    private readonly cmsService: CmsService,
    private readonly appInsightsService: AppInsightsService,
    public readonly multilingualService: MultilingualService,
    private readonly destroyRef: DestroyRef,
    @Inject(BRAND_CONFIG) private brandConfig: BrandConfig
  ) {}

  get brandName(): string {
    return this.brandConfig.displayName;
  }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.PRIVACY_POLICY_VIEWED);
    this.isLoading.set(true);
    this.isError.set(false);
    this.cmsService
      .getPrivacyPolicy()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: CMSContent) => {
          this.privacyPolicy.set(res);
          this.isLoading.set(false);
        },
        error: (err: unknown) => {
          this.isLoading.set(false);
          this.isError.set(true);
          this.errMsg.set(String(err));
        },
      });
  }
}
